import { render, staticRenderFns } from "./physioEdit.vue?vue&type=template&id=1ddc5e64&scoped=true"
import script from "./physioEdit.vue?vue&type=script&lang=js"
export * from "./physioEdit.vue?vue&type=script&lang=js"
import style0 from "./physioEdit.vue?vue&type=style&index=0&id=1ddc5e64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc5e64",
  null
  
)

export default component.exports